import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import PropTypes from 'prop-types';
import React from 'react';
import RowDisplay from '../../common/RowDisplay';
import { useFindConditions } from './hooks/useFindConditions';
var ConditionsList = function ConditionsList(_ref) {
  var list = _ref.list,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(RowDisplay, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "profile-value"
  }, _toConsumableArray(new _Set(_mapInstanceProperty(list).call(list, function (_ref2) {
    var initiative_description = _ref2.initiative_description;
    return initiative_description;
  }))).join(', '))));
};
var PopulationsAndConditionsDisplay = function PopulationsAndConditionsDisplay(_ref3) {
  var contact = _ref3.contact;
  var _useFindConditions = useFindConditions(contact.id),
    conditions = _useFindConditions.conditions,
    populations = _useFindConditions.populations,
    isLoading = _useFindConditions.isLoading;
  return isLoading ? null : /*#__PURE__*/React.createElement(React.Fragment, null, populations !== null && populations !== void 0 && populations.length ? /*#__PURE__*/React.createElement(ConditionsList, {
    list: populations,
    label: "Enhanced Populations"
  }) : null, conditions !== null && conditions !== void 0 && conditions.length ? /*#__PURE__*/React.createElement(ConditionsList, {
    list: conditions,
    label: "Clinical Conditions"
  }) : null);
};
ConditionsList.propTypes = {
  list: PropTypes.array.isRequired
};
PopulationsAndConditionsDisplay.propTypes = {
  contact: PropTypes.object.isRequired
};
export default PopulationsAndConditionsDisplay;
//# sourceMappingURL=PopulationsAndConditionsDisplay.js.map